import React, { Component } from "react";
import { useParams, useNavigate, useLocation, Navigate } from "react-router-dom";
import textosJSON from "./textosContacto.json";
import Select from "react-dropdown-select";

function withRouterAndNavigate(Component) {
  function ComponentWithRouterAndNavigate(props) {
    let params = useParams();
    let navigate = useNavigate();
    let location = useLocation();
    return (
      <Component
        {...props}
        params={params}
        navigate={navigate}
        location={location}
      />
    );
  }
  return ComponentWithRouterAndNavigate;
}

class Contacto extends Component {
  state = {
    email: "",
    emailValido: false,
    nombre: "",
    nombreValido: false,
    telefono: "",
    telefonoValido: false,
    domicilio: "",
    domicilioValido: false,
    provincia: "",
    provinciaValido: false,
    localidad: "",
    localidadValido: false,
    codpostal: "",
    codpostalValido: false,
    motivos: [],
    idMotivo: -1,
    comentarios: "",
    comentariosValido: false,
    motivoValido: false,
    error: null,
    enviando: false,
    enviado: false,
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    const motivos = await fetch("/api/contacto/motivos").then((res) =>
      res.json()
    );
    this.setState({ motivos });
  }

  async registrar() {
    this.setState({ error: null, enviando: true });
    const res = await fetch("/api/contacto", {
      method: "post",
      body: JSON.stringify({
        email: this.state.email,
        nombre: this.state.nombre,
        telefono: this.state.telefono,
        domicilio: this.state.domicilio,
        provincia: this.state.provincia,
        localidad: this.state.localidad,
        codpostal: this.state.codpostal,
        idMotivo: this.state.idMotivo,
        comentarios: this.state.comentarios
      }),
      headers: { "Content-Type": "application/json" },
    });
    const json = await res.json();
    if (json.nroContacto !== -1) {
      this.setState({ enviando: false, enviado: true });
    } else {
      this.setState({ enviando: false, error: true, enviado: false });
    }
  }

  validarMail(email) {
    const emailRegex =
      /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
    if (!email) return false;

    if (email.length > 254) return false;

    let valid = emailRegex.test(email);
    if (!valid) return false;

    var parts = email.split("@");
    if (parts[0].length > 64) return false;

    var domainParts = parts[1].split(".");
    if (
      domainParts.some(function (part) {
        return part.length > 63;
      })
    )
      return false;

    return true;
  }

  customContentRenderer({ props, methods }) {
    return (
      <React.Fragment>
        <div
          className="contacto_select"
          style={{ width: "100%", height: "100%" }}
        >
          <input
            type="text"
            id={props.placeholder_desactivado}
            readOnly={!props.searchable}
            onChange={(event) => methods.setSearch(event)}
            placeholder_desactivado={props.placeholder_desactivado}
            style={{
              border: "none",
              borderColor: "#f5f5f5",
              outline: "none",
              caretColor: "#f5f5f5",
              backgroundColor: "#f5f5f5",
              width: "100%"
            }}
          />
        </div>
      </React.Fragment>
    );
  }

  render() {
    const mobile = window.innerWidth < 1280;
    const idioma = this.props.location.pathname.split("/")[1]
    const texto = (nombre) => {
      return (textosJSON[nombre]?.[idioma])??(textosJSON[nombre]?.["es"])??""
    }
    const styleCampo = {
    };

    const handleChangeMotivo = async (value) => {
      if (value) {
        document.getElementById("Motivo").value = value["motivo_"+idioma];
        this.setState({
          idMotivo: value.id,
          motivoValido: true,
        });
      }
    }
    return (
      !this.state.enviado ? 
      (
      <div style={{
        marginTop: mobile?60:122,
        paddingTop: mobile?60:86,
        paddingBottom: mobile?100:212,
        paddingLeft: "10%",
        paddingRight: "10%",
        backgroundColor: "#ffffff",
        maxWidth: "100%"
      }}
      >
      <div
        style={{
          width: "100%",
          maxWidth: 1013,
          marginLeft: "auto",
          marginRight: "auto"
        }}
      >
        <h1 className="contacto_titulo">{texto("titulo")}</h1>
        <h2 className="contacto_subtitulo">{texto("subtitulo")}</h2>

        <div className="contacto_campo_titulo">
          {texto("motivo")}<span style={{ color: "#ac1519" }}>*</span>
          <Select
            className="contacto_campo"
            style={{
              paddingLeft: 10,
              border: "1px solid #f5f5f5",
              borderRadius: 0,
              backgroundColor: "#f5f5f5"
            }}
            color="#ac1519"
            placeholder_desactivado="Motivo"
            searchable={true}
            separator={true}
            noDataLabel={"No hay resultados."}
            handleKeyDownFn={({ methods, state }) => {
              let input = document.getElementById("Motivo");
              input.focus();
              if (state.values[0]) {
                methods.clearAll();
                input.value = "";
              }
            }}
            separatorRenderer={({ methods }) => {
              this.selectModMethods = methods;
            }}
            dropdownGap={0}
            labelField={"motivo_" + idioma}
            valueField={"id"}
            options={this.state.motivos}
            onChange={(values) => handleChangeMotivo(values[0])}
            contentRenderer={this.customContentRenderer}
          />
        </div>

        <div className="contacto_campo_titulo">
          {texto("nombre")}<span style={{ color: "#ac1519" }}>*</span>
          <input
            className="contacto_campo"
            type="text"
            style={styleCampo}
            onChange={(event) => {
              let valido =
                0 < event.target.value.length &&
                event.target.value.length <= 20;
              if (valido) {
                event.target.style.borderColor = "#f5f5f5";
              } else {
                event.target.style.borderColor = "#ac1519";
              }
              this.setState({
                nombre: event.target.value,
                nombreValido: valido,
                error: null,
              });
            }}
            onKeyUp={(event) => {
              if (event.key === "Enter") {
                document.getElementById("botonEnviar").click();
              }
            }}
          />
        </div>
        
        <div className="contacto_campo_titulo">
          {texto("domicilio")}<span style={{ color: "#ac1519" }}>*</span>
          <input
            className="contacto_campo"
            type="text"
            style={styleCampo}
            onChange={(event) => {
              let valido =
                0 < event.target.value.length &&
                event.target.value.length <= 20;
              if (valido) {
                event.target.style.borderColor = "#f5f5f5";
              } else {
                event.target.style.borderColor = "#ac1519";
              }
              this.setState({
                domicilio: event.target.value,
                domicilioValido: valido,
                error: null,
              });
            }}
            onKeyUp={(event) => {
              if (event.key === "Enter") {
                document.getElementById("botonEnviar").click();
              }
            }}
          />
        </div>

        <div className="contacto_campo_titulo">
          {texto("localidad")}<span style={{ color: "#ac1519" }}>*</span>
          <input
            className="contacto_campo"
            type="text"
            style={styleCampo}
            onChange={(event) => {
              let valido =
                0 < event.target.value.length &&
                event.target.value.length <= 20;
              if (valido) {
                event.target.style.borderColor = "#f5f5f5";
              } else {
                event.target.style.borderColor = "#ac1519";
              }
              this.setState({
                localidad: event.target.value,
                localidadValido: valido,
                error: null,
              });
            }}
            onKeyUp={(event) => {
              if (event.key === "Enter") {
                document.getElementById("botonEnviar").click();
              }
            }}
          />
        </div>

        <div className="contacto_campo_titulo">
          {texto("provincia")}<span style={{ color: "#ac1519" }}>*</span>
          <input
            className="contacto_campo"
            type="text"
            style={styleCampo}
            onChange={(event) => {
              let valido =
                0 < event.target.value.length &&
                event.target.value.length <= 20;
              if (valido) {
                event.target.style.borderColor = "#f5f5f5";
              } else {
                event.target.style.borderColor = "#ac1519";
              }
              this.setState({
                provincia: event.target.value,
                provinciaValido: valido,
                error: null,
              });
            }}
            onKeyUp={(event) => {
              if (event.key === "Enter") {
                document.getElementById("botonEnviar").click();
              }
            }}
          />
        </div>

        <div className="contacto_campo_titulo">
          {texto("codpostal")}<span style={{ color: "#ac1519" }}>*</span>
          <input
            className="contacto_campo"
            type="text"
            style={styleCampo}
            onChange={(event) => {
              let valido =
                0 < event.target.value.length &&
                event.target.value.length <= 10;
              if (valido) {
                event.target.style.borderColor = "#f5f5f5";
              } else {
                event.target.style.borderColor = "#ac1519";
              }
              this.setState({
                codpostal: event.target.value,
                codpostalValido: valido,
                error: null,
              });
            }}
            onKeyUp={(event) => {
              if (event.key === "Enter") {
                document.getElementById("botonEnviar").click();
              }
            }}
          />
        </div>

        <div className="contacto_campo_titulo">
          {texto("telefono")}<span style={{ color: "#ac1519" }}>*</span>
          <input
            className="contacto_campo"
            type="tel"
            style={styleCampo}
            value={this.state.telefono}
            onChange={(event) => {
              event.target.value = event.target.value.replace(
                /[^0-9\+\-\s]/g,
                ""
              );
              let value = event.target.value;
              let valido = 6 < value.length && value.length <= 30;
              if (valido) {
                event.target.style.borderColor = "#f5f5f5";
              } else {
                event.target.style.borderColor = "#ac1519";
              }
              this.setState({
                telefono: value,
                telefonoValido: valido,
                error: null,
              });
            }}
            onKeyUp={(event) => {
              if (event.key === "Enter") {
                document.getElementById("botonEnviar").click();
              }
            }}
          />
        </div>

        <div className="contacto_campo_titulo">
          {texto("email")}<span style={{ color: "#ac1519" }}>*</span>
          <input
            className="contacto_campo"
            type="email"
            style={styleCampo}
            onChange={(event) => {
              let valido = this.validarMail(event.target.value);
              if (valido) {
                event.target.style.borderColor = "#f5f5f5";
              } else {
                event.target.style.borderColor = "#ac1519";
              }
              this.setState({
                email: event.target.value,
                emailValido: valido,
                error: null,
              });
            }}
            onKeyUp={(event) => {
              if (event.key === "Enter") {
                document.getElementById("botonEnviar").click();
              }
            }}
          />
        </div>

        <div className="contacto_campo_titulo">
          {texto("comentarios")}<span style={{ color: "#ac1519" }}>*</span>
          <textarea
            className="contacto_campo"
            placeholder={texto("comentarios")}
            type="text"
            style={{
              height: 200,
            }}
            onChange={(event) => {
              let valido = event.target.value.length > 0;
              if (valido) {
                event.target.style.borderColor = "#f5f5f5";
              } else {
                event.target.style.borderColor = "#ac1519";
              }
              this.setState({
                comentarios: event.target.value,
                comentariosValido: valido,
                error: null,
              });
            }}
            onKeyUp={(event) => {
              if (event.key === "Enter") {
                document.getElementById("botonEnviar").click();
              }
            }}
          />
      </div>

        <div style={{marginTop: 48,width: "100%", display: "flex", justifyContent: "left"}}>
        <button
          id="botonEnviar"
          className="contacto_recuadro_boton"
          disabled={
            !(
              this.state.codpostalValido &&
              this.state.comentariosValido &&
              this.state.domicilioValido &&
              this.state.emailValido &&
              this.state.localidadValido &&
              this.state.motivoValido &&
              this.state.nombreValido &&
              this.state.provinciaValido &&
              this.state.telefonoValido &&
              this.state.error == null &&
              !this.state.enviando
            )
          }
          onClick={() => this.registrar()}
        >
          Enviar
        </button>
        </div>
      </div>
      </div>
      )  
      : 
      (
        <Navigate to={"/" + idioma + "/contact/success"} replace={true} />
      )
    );
  }
}

export default withRouterAndNavigate(Contacto);
